<template>
  <v-container>
    <h2>Create user</h2>
    <v-row>
      <v-col lg="10" md="12" sm="12">
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="user.firstname"
              label="Firstname"
              :rules="[rules.require]"
              outlined
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="user.lastname"
              label="Lastname"
              outlined
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="user.username"
              label="Username"
              :rules="[rules.require]"
              outlined
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="user.email"
              label="Email"
              outlined
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="user.phone_number"
              label="Phone number"
              outlined
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="user.line_id"
              label="Line ID"
              outlined
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-select
              :items="role_list"
              item-text="label"
              item-value="value"
              label="Role"
              v-model="user.role_id"
              outlined
              dense
            ></v-select>
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-switch
              v-model="user.active"
              label="Active"
              inset
              color="orange"
            ></v-switch>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <div class="text-left">
          <v-btn
            class="mx-2"
            small
            color="orange"
            dark
            @click="createUser"
          >
            Create
          </v-btn>
          <v-btn
            class="mx-2"
            small
            exact
            :to="{ name: 'user-list' }"
          >
            Cancel
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { authHeader } from '../../../_helpers';
export default {
  name: "UserCreate",
  components: {

  },
  data: () => ({
    user: {
      firstname: null,
      lastname: null,
      username: null,
      email: null,
      phone_number: null,
      line_id: null,
      role_id: null,
      active: true
    },
    role_list: [ ],
    rules: {
      profile_image: value => !value || value.size < 2000000 || 'Avatar size should be less than 2 MB!',
      require: value => !!value || 'Please fill in information'
    },
  }),
  async mounted () {
    await this.getRoleList()
  },
  methods: {
    async createUser () {
      try {
        if (this.requireField()) {
          await this.$http.post('/back-office/admins', this.user, authHeader())
          this.$router.push({ name: 'user-list'})
        }
      } catch (err) {
        console.log(err)
        alert('Something went wrong')
      }
    },
    requireField () {
      if (!this.user.firstname) {
        alert('Please fill in firstname')
        return false;
      } else if (!this.user.username) {
        alert('Please fill in username')
        return false;
      } else if (!this.user.role_id) {
        alert('Please select role')
        return false;
      }
      return true
    },
    async getRoleList () {
      const { data } = await this.$http.get('/back-office/roles', authHeader())
      data.forEach(item => {
        this.role_list.push({
          label: item.role_name,
          value: item.id
        })
      })
    }
  },
};
</script>
